import * as auth from '@/api/auth'
// import { setToken, parserHttpError } from '@/utils/axios'
// import { setToken } from '@/utils/axios'

const state = {
  loggedInUser:
    window.localStorage.getItem('userInfo') != null
      ? JSON.parse(window.localStorage.getItem('userInfo'))
      : null,
  loading: false,
  error: null,
  confirmaSenha: {
    estado: false,
    acesso: { tela: null, funcionalidade: null },
    token: false,
    onConfirm: () => {
    },
    onClose: () => {
    }
  }
}

const getters = {
  loggedInUser: state => state.loggedInUser,
  loading: state => state.loading,
  error: state => state.error,
  funcionalidades: (state) => (param) => {
    if (state.loggedInUser &&
      state.loggedInUser.acesso &&
      state.loggedInUser.acesso.funcionalidades &&
      state.loggedInUser.acesso.funcionalidades[param] === 'S') return state.loggedInUser.acesso.funcionalidades[param]
    return {}
  },
  telas: (state) => (param) => {
    if (state.loggedInUser &&
      state.loggedInUser.acesso &&
      state.loggedInUser.acesso.telas &&
      state.loggedInUser.acesso.telas[param] === 'S') return state.loggedInUser.acesso.telas[param]
    return {}
  },
  token: (state) => (acesso) => {
    // Valida Tela
    if (acesso &&
      acesso.tela &&
      state.confirmaSenha.acesso.tela &&
      state.confirmaSenha.token &&
      state.confirmaSenha.acesso.tela === acesso.tela) {
      return state.confirmaSenha.token
    }
    // Valida Funcionalidade
    if (acesso &&
      acesso.funcionalidade &&
      state.confirmaSenha.acesso.funcionalidade &&
      state.confirmaSenha.token &&
      state.confirmaSenha.acesso.funcionalidade === acesso.funcionalidade) {
      return state.confirmaSenha.token
    }
    return (state.loggedInUser && state.loggedInUser.token) ? state.loggedInUser.token : undefined
  }
}

const mutations = {
  setUser (state, data) {
    state.loggedInUser = data
    state.loading = false
    state.error = null
    // console.log(state.loggedInUser)
    window.localStorage.setItem('userInfo', JSON.stringify(state.loggedInUser))
  },
  setLogout (state) {
    state.loggedInUser = null
    state.loading = false
    state.error = null
    window.localStorage.removeItem('userInfo')
    // this.$router.go("/");
  },
  setLoading (state, data) {
    state.loading = data
    state.error = null
  },
  setError (state, data) {
    state.error = data
    state.loggedInUser = null
    state.loading = false
    window.localStorage.removeItem('userInfo')
  },
  clearError (state) {
    state.error = null
  }
  // setToken (state, payload) {
  // localStorage.setItem('token', payload)
  // setToken(auth, payload)
  // state.token = payload
  // }
}

const actions = {
  // readToken: ({ commit }) => new Promise(resolve => {
  //   const token = localStorage.getItem('userInfo')
  //   const username = localStorage.getItem('username')
  //
  //   if (!token) {
  //     commit('setLogout')
  //     return resolve()
  //   }
  //
  //   commit('SET_TOKEN', token)
  //   commit('SET_USERNAME', username)
  //   resolve()
  // }),
  async login ({ commit }, data) {
    commit('clearError')
    commit('setLoading', true)

    try {
      const retorno = await auth.login(data)
      commit('setUser', retorno)
      return retorno
    } catch (e) {
      await commit('setError', e)
    }
  },

  signOut ({ commit }) {
    window.localStorage.removeItem('userInfo')
    window.localStorage.removeItem('fingerprint')
    commit('setLogout')
  }
}

export default { namespaced: true, state, getters, mutations, actions }
